export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openExcelImportForm({commit}) {
        commit('setExcelImportFormOpen');
    },
    closeExcelImportForm({commit}) {
        commit('setExcelImportFormClose');
    }
}
